export default __webpack_public_path__ + "static/media/section1_tool.91f21d79.png";